import { makeQuery, isExternal } from './../util/url';
import config from './../config';
// import variables from './../config';

class Service {
  constructor (options) {
    this._defaults = {};
    this._options = Object.assign({}, this._defaults, options || {});
  }

  request = (method, path, { params = {} } = {}) => {
    const { _options: { base = '', json } } = this;
    if (json) params.format = 'json';
    if (Object.keys(params).length) path += '?' + makeQuery(params);
    const url = base + path;
    return new Promise((resolve, reject) => {
      let request;
      if (isExternal(url) && window.XDomainRequest) {
        request = new window.XDomainRequest();
        request.onload = () => {
          try {
            let response = JSON.parse(request.responseText);
            resolve(response);
          } catch (error) {
            reject(Object.assign(new Error('Error parsing response.'), { error }));
          }
        };
      } else {
        request = new window.XMLHttpRequest();
        request.onreadystatechange = () => {
          if (request.readyState === 4) {
            if (
              request &&
              !(
                typeof request.status === 'number' &&
                request.status < 200 &&
                request.status >= 400
              )
            ) {
              try {
                let response = JSON.parse(request.responseText);
                resolve(response);
              } catch (error) {
                reject(Object.assign(new Error('Error parsing response.'), { error }));
              }
            } else {
              reject(Object.assign(new Error('Error in API service.')));
            }
          }
        };
      }
      request.open(method.toUpperCase(), url, true);
      request.send();
    });
  };

  get = (path, { params } = {}) => this.request('get', path, { params });
  post = (path, { params } = {}) => this.request('post', path, { params });
}

export default new Service({
  base: config.api,
  json: true
});
